import {connect} from '@modifi/redux'
import {aCloseDialog, aShowDialog} from '@modifi/plugin-dialogs'
import {aAddSnackBar} from '@modifi/plugin-snackbars'
import {getAuthenticatedAdminAresClient} from '@modifi/trade-api-clients'

import BulkMatchingDialog, {BulkMatchingDialogProps} from './BulkMatchingDialog'
import {aFetchTransaction, selectTransactionId} from '../../../../data/transaction'
import {aFetchWithFilterParams} from '../../../payments/store'
import {aResetMatchList, aPreSetMatchList} from '../../../transaction-details/store'

export const DIALOG_NAME = 'bulk-matching'

const mapStateToProps = (state: Record<string, any>): Pick<BulkMatchingDialogProps, 'search'> => ({
  search: (searchString: string): Promise<any> => {
    const client = getAuthenticatedAdminAresClient()
    return client.Payments.open({
      pageSize: 10,
      transactionId: selectTransactionId(state),
      'search.order.orderReferenceCode': searchString,
      resultFields: ['payments.order.orderReferenceCode', 'payments.externalId'],
    }).then(res => res.data()?.payments)
  },
})

const mapDispatchToProps = {
  fetchTransaction: aFetchTransaction,
  handleClose: aCloseDialog,
  showDialog: aShowDialog,
  fetchWithFilterParams: aFetchWithFilterParams,
  setMatchingList: aPreSetMatchList,
  clearMatchList: aResetMatchList,
  addSnackBar: aAddSnackBar,
}

export default connect(mapStateToProps, mapDispatchToProps)(BulkMatchingDialog)
